const validate = (values) => {
    const errors = {};
    //eslint-disable-next-line
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!values.email) {
        errors.email = 'Required';
    }
    if (values.email && !re.test(values.email)) {
        errors.email = 'Invalid email';
    }
    if (!values.password) {
        errors.password = 'Required';
    }
    return errors;
};

export default validate;
